import React from 'react'
import { Button, Container, Row, Col } from '@doseme/cohesive-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

import { capitalizeString } from '../../utils/stringUtils'

import './index.scss'

interface IProps {
  entityType: string
  entityName?: string
  cancel: () => any
  confirm: () => any
}

const ConfirmModal: React.FC<IProps> = (props) => {
  return (
    <div data-testid='confirm-modal' className='confirm-modal'>
      <Container>
        <Row>

          <Col width={2}>
            <FontAwesomeIcon
              className='fa-xs delete-icon'
              icon={faTrash}
            />
          </Col>

          <Col>
            <h4 className='co-h4 pb-2'>Delete {capitalizeString(props.entityType)}</h4>
            <div className='confirm-subtitle'>{props.entityName || ''}</div>
            <div>
              The selected {props.entityType}(s) will be permanently deleted from the system.<br />
              This action cannot be undone.
            </div>
          </Col>

          <Col width={2}>
          </Col>
        </Row>

        <Row className='buttons'>
          <Col>
            <div className='d-flex justify-content-end'>
              <Button
                data-testid='confirm-modal-cancel'
                variant='light'
                className='mr-3'
                onClick={props.cancel}
              >
                Cancel
              </Button>
              <Button
                data-testid='confirm-modal-delete'
                variant='danger'
                onClick={props.confirm}
              >
                Erase this {capitalizeString(props.entityType)}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export {
  ConfirmModal
}
